export default {
  methods: {

    async createMethod(object, service) {

      try {
        this.$emit('loading', true)
        const response = await service.create(object)

        if(response) {
          console.log('// Create Response');
          this.$emit('success', response);
        }
        
      } catch(error) {
        const ERROR_MESSAGES = this.$i18n.t('error_messages');
        this.$emit('loading', false)

        if(error == 'Error: Network Error') {
          if(navigator.onLine) {
            return this.error = ERROR_MESSAGES.server_error;  
          } else {
            // return this.error = ERROR_MESSAGES.internet_connection;
          }
        }
        
        function modulari18(THISINSTANCE, errorString, string) {
          return THISINSTANCE.$emit('error', 
            THISINSTANCE.$i18n.t('error_messages.field_' + string, { 
              text: THISINSTANCE.$i18n.t('fields.' + errorString.substring(0, errorString.indexOf('-' + string))) 
            }
          ));
        }

        if(error.response.data.indexOf(' ') >= 0) {
          return this.$emit('error', error.response.data);
        }

        if(error.response.status == 403) 
          return this.$emit('error', ERROR_MESSAGES[error.response.data])

        if(error.response.status == 429)
          return this.$emit('error', ERROR_MESSAGES.too_many_attempts);

        const error_string = error.response.data;

        if(error_string == 'invalid-fields')
          return this.$emit('error', ERROR_MESSAGES.invalid_fields);

        if(error_string.includes('required'))
          return modulari18(this, error_string, 'required');

        if(error_string.includes('invalid'))
          return modulari18(this, error_string, 'invalid');

        if(error_string.includes('unknown'))
          return modulari18(this, error_string, 'unknown');

        if(error_string.includes('exists'))
          return modulari18(this, error_string, 'exists');

        console.log('error')
        console.log(error)

        return this.$emit('error', ERROR_MESSAGES.generic);
      }
    },

    async deleteMethod(id, service) {
      
      try {
        this.$emit('loading', true)
        const response = await service.delete(id)

        if(response) {
          this.$emit('deleted', response);
        }
        
      } catch(error) {
        const ERROR_MESSAGES = this.$i18n.t('error_messages');
        this.$emit('loading', false)
        if(error == 'Error: Network Error') {
          if(navigator.onLine) {
            console.log(error);
            return this.error = ERROR_MESSAGES.server_error;  
          }
        }
        
        if(error.response.status == 403) 
          return this.$emit('error', ERROR_MESSAGES[error.response.data])

        if(error.response.status == 429)
          return this.$emit('error', ERROR_MESSAGES.too_many_attempts);

        return this.$emit('error', ERROR_MESSAGES.generic);
      }
    },

    async crudGetPage(object, service) {
      
      try {
        this.$emit('loading', true)
        const response = await service.get_multiple(object)

        if(response)
          this.$emit('success', response.data);
        
      } catch(error) {
        const ERROR_MESSAGES = this.$i18n.t('error_messages');
        this.$emit('loading', false)
        if(error == 'Error: Network Error') {
          if(navigator.onLine) {
            console.log(error);
            return this.error = ERROR_MESSAGES.server_error;  
          } else {
            // return this.error = ERROR_MESSAGES.internet_connection;
          }
        }
        
        if(error.response.status == 403) {

          if(error.response.data == "no_user" || error.response.data == 'Not Authenticated') {
            return this.forceLogout();
          }
          return this.$emit('error', ERROR_MESSAGES[error.response.data])

        }
          
          

        if(error.response.status == 429)
          return this.$emit('error', ERROR_MESSAGES.too_many_attempts);

        return this.$emit('error', ERROR_MESSAGES.generic);
      }
    },

    async crudGet(object, service) {
      
      try {
        this.$emit('loading', true)
        const response = await service.get_single(object)

        if(response) {
          this.$emit('get', response);
        }
        
      } catch(error) {
        const ERROR_MESSAGES = this.$i18n.t('error_messages');
        this.$emit('loading', false)
        if(error == 'Error: Network Error') {
          if(navigator.onLine) {
            console.log(error);
            return this.error = ERROR_MESSAGES.server_error;  
          }
        }
        
        if(error.response.status == 403) 
          return this.$emit('error', ERROR_MESSAGES[error.response.data])

        if(error.response.status == 429)
          return this.$emit('error', ERROR_MESSAGES.too_many_attempts);

        return this.$emit('error', ERROR_MESSAGES.generic);
      }
    },
    async crudUpdate(object, service) {
      
      try {
        this.$emit('loading', true)
        const response = await service.save(object)

        if(response) {
          // console.log('// Create Response');
          this.$emit('updated', response);
        }
        
      } catch(error) {
        const ERROR_MESSAGES = this.$i18n.t('error_messages');
        this.$emit('loading', false)
        if(error == 'Error: Network Error') {
          if(navigator.onLine) {
            console.log(error);
            return this.error = ERROR_MESSAGES.server_error;  
          } else {
            // return this.error = ERROR_MESSAGES.internet_connection;
          }
        }
        
        if(error.response.status == 403) 
          return this.$emit('error', ERROR_MESSAGES[error.response.data])

        if(error.response.status == 429)
          return this.$emit('error', ERROR_MESSAGES.too_many_attempts);

        if(error.response.status == 400)
          if(error.response.data == 'invalid-fields')
            return this.$emit('error', ERROR_MESSAGES.invalid_fields);    

        return this.$emit('error', ERROR_MESSAGES.generic);
      }
    },
    crudCreate(object, form, service) {
      this.$swal.fire({
        title: typeof form !== 'undefined' && typeof form.title !== 'undefined' ? form.title : 'no title defined',
        text: typeof form !== 'undefined' && typeof form.text !== 'undefined' ? form.text : 'no text defined',
        type: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#6b6b6b',
        confirmButtonText: this.$t('interface.yes'),
        cancelButtonText: this.$t('interface.no')
      }).then((result) => {
        if (result.value)
          this.createMethod(object, service);
      });
    },
    crudDelete(object, form, service) {
      this.$swal.fire({
        title: typeof form !== 'undefined' && typeof form.title !== 'undefined' ? form.title : 'no title defined',
        text: typeof form !== 'undefined' && typeof form.text !== 'undefined' ? form.text : 'no text defined',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#6b6b6b',
        confirmButtonText: this.$t('interface.yes'),
        cancelButtonText: this.$t('interface.no')
      }).then((result) => {
        if (result.value)
          this.deleteMethod(object, service);
      });
    },
    async crudSearch(object, form, service) {

      const ipAPI = 'https://api.ipify.org?format=json'

      const inputValue = fetch(ipAPI)
        .then(response => response.json())
        .then(data => data.ip)
      
      const { value: ipAddress } = await Swal.fire({
        title: 'Enter example search string.',
        input: 'text',
        inputValue: inputValue,
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return 'Search fail.'
          }
        }
      })
      
      if (ipAddress) {
        Swal.fire(`Your IP address is ${ipAddress}`)
      }
      /*
      this.$swal.fire({
        title: typeof form !== 'undefined' && typeof form.title !== 'undefined' ? form.title : 'no title defined',
        text: typeof form !== 'undefined' && typeof form.text !== 'undefined' ? form.text : 'no text defined',
        type: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#6b6b6b',
        confirmButtonText: this.$t('interface.yes'),
        cancelButtonText: this.$t('interface.no')
      }).then((result) => {
        if (result.value)
          this.createMethod(object, service);
      });
      */
    }
  }
}